import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useContentfulPromotionContent from 'hooks/useContentfulPromotionContent';
import BannerTextSection from 'components/consumer/image-with-text-banner2/BannerTextSection';
const ShopPagePromotionPanel = () => {
  const $ = _c(8);
  const {
    promotionData
  } = useContentfulPromotionContent();
  const [textContent, updateTextContent] = useState(null);
  const [colors, updateColors] = useState(null);
  const [ctaColors, updateCtaColors] = useState(null);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const toggleInputType = t0;
  let t1;
  let t2;
  if ($[1] !== promotionData) {
    t1 = () => {
      if (!promotionData) {
        return;
      }
      const {
        title,
        body,
        disclaimer,
        icon,
        backgroundImage,
        heroTextBackgroundColor,
        heroFancyText,
        heroFancyTextColor,
        heroLogomark,
        mainTextColor,
        ctaTextColor,
        ctaBackgroundColor
      } = promotionData;
      updateTextContent({
        icon,
        heroFancyText,
        heroFancyTextColor,
        heroLogomark,
        body,
        title,
        disclaimer,
        backgroundImage
      });
      updateColors({
        textHex: mainTextColor,
        backgroundHex: backgroundImage ? "transparent" : heroTextBackgroundColor
      });
      updateCtaColors({
        textHex: ctaTextColor,
        backgroundHex: ctaBackgroundColor
      });
    };
    t2 = [promotionData];
    $[1] = promotionData;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!textContent) {
    return null;
  }
  let t3;
  if ($[4] !== colors || $[5] !== ctaColors || $[6] !== textContent) {
    t3 = <div className="[grid-area:ShopPagePromotionPanel] object-cover max-[767px]:items-center max-[767px]:flex max-[767px]:flex-col max-[767px]:pt-6 max-[767px]:px-6 max-[767px]:pb-8 max-[767px]:text-center"><BannerTextSection config={{
        textContent,
        colors,
        ctaColors,
        toggleInputType
      }} isHomepage={false} variant="ShopPagePromotionPanel" /></div>;
    $[4] = colors;
    $[5] = ctaColors;
    $[6] = textContent;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
ShopPagePromotionPanel.propTypes = {
  config: PropTypes.shape({
    textContent: PropTypes.shape({
      title: PropTypes.string,
      subTitle: PropTypes.string,
      disclaimer: PropTypes.string
    }),
    colors: PropTypes.shape({
      backgroundHex: PropTypes.string,
      textHex: PropTypes.string
    }),
    image: PropTypes.shape({
      path: PropTypes.string
    }),
    background: PropTypes.shape({
      imagePath: PropTypes.string
    })
  })
};
export default ShopPagePromotionPanel;